import React, { FC } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

// Styles
const StyledListGroupItem = styled.li`
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0 !important;
  }

  span {
    border-radius: 50%;
    height: 52px;
    margin-right: 0.75rem;

    svg {
      height: 44px;
      width: 44px;
    }
  }
`;

// Props
interface IProps {
  background?: string | null;
  icon: any;
  text: string;
}

const ListGroupItem: FC<IProps> = ({ background = null, icon, text }) => {
  const { t } = useTranslation();
  const bgColor = background ? `bg-${background}` : "";

  return (
    <StyledListGroupItem className="d-flex flex-row align-items-center justify-content-center">
      <span
        className={`d-flex align-items-center justify-content-center ${bgColor}}`}
      >
        {icon}
      </span>
      <p className="mb-0">{t(text)}</p>
    </StyledListGroupItem>
  );
};

export default ListGroupItem;
